<template>
  <div class='attachments'>
    <span class='label' :style='labelStyle'>{{ labelText }}</span>
    <div class='attachmentsContent'>
      <el-upload class='avatar-uploader' :action='attachmentsUploadUrl' :show-file-list='false' :disabled="disabled"
        :on-success='cropUploadSuccess' :before-upload="beforeUpload" :data='{ type: typeNum }'>
        <img v-if='value' :src='value' class='avatar'>
        <i v-else class='el-icon-plus avatar-uploader-icon'></i>
      </el-upload>
      <span class="text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
// import CryptoJS from 'crypto-js'
export default {
  name: 'anyImageUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    value: '',
    labelWidth: String,
    width: Number,
    height: Number,
    type: Number,
    text: String
  },
  data() {
    return {
      imageUrl: this.value,
      showBigImage: false,
      attachmentsUploadUrl: pubServer + '/upload/v2/upload',
      // attachmentsUploadUrl: 'https://uat-nikegetit2.nike.com/public-service-new/upload/upload',
      labelText: this.label ||'',
      typeNum: this.type || 6,
      hash: ''
    }
  },
  methods: {
    cropUploadSuccess(jsonData, field) {
      if (jsonData.code == 200) {
        this.imageUrl = jsonData.data.result.imageUrl
        this.$emit('input', this.imageUrl)
      }else{
        this.$message.error(jsonData.message);
      }

    },
    async beforeUpload(file) {
      const isJPG_PNG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';

      if (!isJPG_PNG) {
        this.$message.error('图片上传仅支持 JPG 或 PNG 格式!');
        throw new Error('图片上传仅支持 JPG 或 PNG 格式!');
      }
      // this.hash = await this.getFileHash(file)

      return isJPG_PNG;
    },
    // async getFileHash(file) {
    //   return new Promise(function (resolve, reject) {
    //     let reader = new FileReader();
    //     reader.readAsArrayBuffer(file);
    //     reader.onload = function (evt) {
    //       let fileStr = evt.target.result;
    //       let wordArray = CryptoJS.lib.WordArray.create(fileStr);
    //       let fileHash = CryptoJS.SHA256(wordArray).toString().toLowerCase();
    //       resolve(fileHash);
    //     }
    //   })
    // },
  },
  computed: {
    labelStyle() {
      const w = this.labelWidth || '100'
      return {
        width: w + 'px'
      }
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.imageUrl = val
    },
    label: function (val, oldVal) {
      this.labelText = val
    }
  }
}
</script>

<style scoped lang='sass'>
  .attachments
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0
    .input-box
      font-size: 12px
      color: #606266
      span
        margin-left: 5px
    .attachmentsContent
      line-height: 36px
      width: 100%
      .upload-image
        width: 150px
      .text
        font-size: 12px
        line-height: 26px
        color: #606266

  .avatar-uploader .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

  .avatar-uploader .el-upload:hover
    border-color: #409EFF

  .avatar-uploader-icon
    font-size: 20px
    color: #8c939d
    width: 150px
    height: 150px
    line-height: 150px
    text-align: center
    border: 1px dashed #ccc
    background: #fff

  .avatar
    width: 150px
    display: block
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/anyImageUpload.vue